import api from './default'

export default api('/api/enrollment', 'enrollments')
